import TomSelect from "tom-select";

document.addEventListener("DOMContentLoaded", function () {
  const selectElement = document.querySelector("#evento-select");

  if (!selectElement) return;

  // Inicializa o TomSelect
  const select = new TomSelect("#evento-select", {
    create: true,
    allowEmptyOption: false,
    sortField: {
      field: "text",
      direction: "asc",
    },
  });

  // Função para pegar parâmetros da URL
  function getUrlParameter(name) {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(name);
  }

  // Pega o valor do parâmetro 'event' na URL
  const eventoSelecionado = getUrlParameter("event");

  // Verifica se o parâmetro existe e seleciona a opção correspondente
  if (eventoSelecionado) {
    const optionToSelect = selectElement.querySelector(
      `option[value="${eventoSelecionado}"]`
    );

    if (optionToSelect) {
      // Após o TomSelect ser inicializado, definimos o valor
      select.setValue(eventoSelecionado); // Atualiza o valor no TomSelect
    }
  } else {
    console.log("TCL: eventoSelecionado não encontrado", eventoSelecionado);
  }

  // Atualiza informações ao selecionar
  const eventoInfo = document.getElementById("evento-info");
  const eventoTitulo = document.querySelectorAll(".event-name");
  const eventoLocal = document.querySelectorAll(".event-local");
  const eventoData = document.querySelectorAll(".event-date");

  // Função para exibir informações com base na opção selecionada
  function exibirInformacoes(eventoId) {
    const selectElement = document.querySelector("#evento-select");
    const selectedOption = selectElement.querySelector(
      `option[value="${eventoId}"]`
    );

    if (selectedOption) {
      const titleText = selectedOption.getAttribute("data-title");
      const localText = selectedOption.getAttribute("data-local");
      const dataText = selectedOption.getAttribute("data-data");

      document.querySelector("#main-product-event-id").value =
        selectedOption.value;
      document.querySelector("#main-product-event-name").value = titleText;
      document.querySelector("#main-product-event-local").value = localText;
      document.querySelector("#main-product-event-date").value = dataText;

      // Atualiza os campos com os dados do evento
      eventoTitulo.forEach((title) => {
        title.textContent = titleText;
      });
      eventoLocal.forEach((local) => {
        local.textContent = localText;
      });
      eventoData.forEach((data) => {
        data.textContent = dataText;
      });

      eventoInfo.style.display = "block"; // Exibe as informações
    } else {
      eventoInfo.style.display = "none"; // Esconde se não houver seleção
    }
  }

  // Se o parâmetro de URL já foi selecionado, exibe as informações imediatamente
  if (eventoSelecionado) {
    select.setValue(eventoSelecionado); // Se o parâmetro já foi passado via URL
    exibirInformacoes(eventoSelecionado);
  }

  // Ouve a mudança na seleção do evento
  select.on("change", function (value) {
    exibirInformacoes(value);
  });
});
